export interface ValidationErrorInterface {
  field: string
  message: string
  number?: number
  context?: object
}

export class ValidationError implements ValidationErrorInterface {
  field: string
  message: string
  number?: number
  context?: object

  constructor(props: ValidationErrorInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      field: _field,
      message: _message,
      number: _number,
      context: _context,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.field = _field
    this.message = _message
    this.number = _number
    this.context = _context
  }
}
